import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { publicHeader } from "../../data/PublicData";
import Logo from "../../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM copy.jpeg";

export const PublicHeader = () => {

    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation(); // current page detect

    return (
        <header className="sticky top-0 z-50 bg-primary-50/95 backdrop-blur-sm border-b border-secondary-100">

            <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">

                {/* Logo */}
                <div onClick={() => navigate("/")} className="cursor-pointer">
                    <img src={Logo} alt="logo" className="object-cover h-12" />
                </div>

                {/* Navigation */}
                <nav
                    className={`${open ? "flex" : "hidden"
                        } absolute md:static top-full left-0 w-full md:w-auto bg-white md:bg-transparent
          md:flex flex-col md:flex-row gap-6 md:gap-8 px-6 md:px-0 py-6 md:py-0 shadow-md md:shadow-none`}
                >
                    {publicHeader.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <span
                                key={item.path}
                                onClick={() => navigate(item.path)}
                                className={`relative font-medium cursor-pointer transition duration-300
                                
                                ${isActive
                                        ? "text-primary-600 font-semibold"
                                        : "text-gray-800"
                                    }

                                after:absolute after:left-0 after:-bottom-1 after:h-[2px]
                                after:bg-primary-600 after:transition-all after:duration-300
                                
                                ${isActive
                                        ? "after:w-full"
                                        : "after:w-0 hover:after:w-full"
                                    }
                                `}
                            >
                                {item.label}
                            </span>
                        );
                    })}
                </nav>

                {/* Right Actions */}
                <div className="flex items-center gap-3">

                    {/* Login */}
                    <button
                        onClick={() => navigate("/login")}
                        className="px-4 py-1.5 rounded-lg text-sm font-medium
            text-primary-600 border border-primary-600
            hover:bg-primary-600 hover:text-white transition"
                    >
                        Login
                    </button>

                    {/* Register */}
                    <button
                        onClick={() => navigate("/register")}
                        className="hidden md:block px-4 py-1.5 rounded-lg text-sm font-medium
            bg-primary-600 text-white
            hover:bg-primary-700 transition"
                    >
                        Register
                    </button>

                    {/* Mobile Menu */}
                    <button
                        className="md:hidden text-2xl text-primary-600"
                        onClick={() => setOpen(!open)}
                    >
                        ☰
                    </button>
                </div>
            </div>
        </header>
    );
};